export default __webpack_public_path__ + "static/media/vision.bee6321a.svg";